export const form = {
  email: {
    label: 'E-Mail',
    placeholder: 'Geben Sie die Adresse der Mail ein'
  },
  name: {
    label: 'Name',
    placeholder: 'Geben Sie den Namen ein'
  },
  clubName: {
    label: 'Der Name des Clubs',
    placeholder: 'Geben Sie den Namen des Clubs ein',
    description: 'Geben Sie den Namen per Latein ein'
  },
  address: {
    label: 'Adresse',
    placeholder: 'Geben Sie die Adresse ein'
  },
  workPeriod: {
    start: {
      placeholder: 'Der Beginn der Arbeit'
    },
    end: {
      placeholder: 'Ende der Arbeit'
    }
  },
  workTime: {
    start: {
      label: 'Öffnungszeit'
    },
    end: {
      label: 'Schließzeit'
    }
  },
  country: {
    label: 'Geben Sie den Standort des Clubs an',
    placeholder: 'Geben Sie den Standort des Clubs an'
  },
  role: {
    label: 'Stellenangebote im Club'
  },
  currency: {
    label: 'Geben Sie die Zahlungswährung an die Künstler an',
    placeholder: 'Geben Sie die Zahlungswährung an die Künstler an'
  },
  nativeLanguage: {
    label: 'Muttersprache',
    placeholder: 'Geben Sie Ihre Muttersprache an'
  },
  lastName: {
    label: 'Nachname',
    placeholder: 'Geben Sie Ihren Nachnamen ein'
  },
  birth: {
    label: 'Geburtsdatum',
    placeholder: 'Geben Sie das Geburtsdatum ein'
  },
  password: {
    label: 'Passwort',
    placeholder: 'Geben Sie das Passwort ein',
    description:
      'Das Passwort muss mindestens 8 Zeichen des oberen und unteren Registers, Zahlen und Sonderzeichen enthalten (z. B.!, @, #, $)'
  },
  resetPassword: {
    new: {
      label: 'Neues Passwort',
      placeholder: 'Geben Sie ein neues Passwort ein'
    },
    confirm: {
      label: 'Bestätigen Sie das Passwort',
      placeholder: 'Geben Sie ein neues Passwort ein'
    }
  },
  penalties: {
    placeholder: 'Geben Sie den Namen der Geldstrafe ein'
  },
  phone: {
    label: 'Telefonnummer',
    placeholder: '+373-000-00-00'
  },
  buttons: {
    continue: 'Weitermachen',
    login: 'Eingang',
    send: 'Schicken',
    cancel: 'Stornieren',
    confirm: 'Bestätigen',
    resend: 'Erneut senden',
    register: 'Registrieren',
    registerRequest: 'Hinterlassen Sie einen Antrag auf Registrierung'
  },
  links: {
    forgotPasswordLink: 'Das Passwort vergessen?',
    login: 'Eingeben',
    haveAccount: 'Ich habe bereits ein Konto',
    privacy: 'Benutzervereinbarung und Vertraulichkeitsrichtlinie.'
  },
  other: {
    or: 'Oder'
  },
  approximateStartDate: {
    label: 'Ungefähres Arbeitsdatum'
  },
  approximateEndDate: {
    label: 'Ungefähres Datum des Arbeitsende'
  },
  search: {
    placeholder: 'Suchen',
    placeholderCitizienship: 'Suche nach Staatsbürgerschaft'
  },
  positionItem: {
    label: 'Geben Sie eine Position ein'
  },
  paymentFrequency: {
    label: 'Die Häufigkeit der Zahlungen'
  },
  price: {
    label: 'Preis'
  },
  priceForArtist: {
    label: 'Summe an den Künstler'
  },
  artistPercent: {
    label: 'Prozentsatz für den Künstler'
  }
};
